import React, { useContext, useState } from 'react'
import Modal from 'react-modal'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Flex } from 'rebass'

import { GameDifficultyContext } from '../utils/GameModeContext'
import CONST from '../utils/const'
import { useMediaQuery } from 'react-responsive'

const {
  DIFFICULTY: { NOVICE, PRO }
} = CONST

const overlayModalClass = css`
  background: transparent;
`

const customStyles = {
  content: {
    backgroundColor: '#6dd9e0',
    borderRadius: '4px',
    margin: 'auto',
    width: '25%',
    height: '35%'
  }
}

const customStylesMobile = {
  content: {
    backgroundColor: '#6dd9e0',
    borderRadius: '4px',
    width: '99vw',
    height: '99vh',
    padding: 0,
    left: 0,
    top: 0
  }
}

const Title = styled('div')`
  text-transform: uppercase;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
`

const SubTitle = styled('span')`
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
`

const Smiley = styled('span')`
  text-align: center;
  font-size: 100px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }
`

const GameModeChooseModal = () => {
  const { setGameDifficultyMode } = useContext(GameDifficultyContext)
  const [showGameModeModal, setShowGameModeModal] = useState(true)
  const isSmallScreen = useMediaQuery({
    query: '(max-width: 1366px)'
  })

  const handleModalShow = (difficulty) => {
    setShowGameModeModal(!showGameModeModal)
    setGameDifficultyMode(difficulty)
  }

  return (
    <Modal
      style={isSmallScreen ? customStylesMobile : customStyles}
      overlayClassName={overlayModalClass.name}
      isOpen={showGameModeModal}
      ariaHideApp={false}>
      <Title>Choose one to enter game 🎮</Title>
      <Flex justifyContent="space-evenly" height="80%" alignItems="center">
        <Flex flexDirection="column">
          <Smiley
            onClick={() => {
              handleModalShow(NOVICE)
            }}>
            👶🏻
          </Smiley>
          <SubTitle>{NOVICE}</SubTitle>
        </Flex>
        <Flex flexDirection="column">
          <Smiley
            onClick={() => {
              handleModalShow(PRO)
            }}>
            💪🏻
          </Smiley>
          <SubTitle>{PRO}</SubTitle>
        </Flex>
      </Flex>
    </Modal>
  )
}

export default GameModeChooseModal
